module.exports = __webpack_public_path__ + "static/media/snowhill-wharf.921e8022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/snowhill-wharf.jpg
// module id = 304
// module chunks = 0